export default __webpack_public_path__ + "static/media/Simple-Line-Iconsd41d.cb4840b5.eot";